<div
  *ngIf="enableMessage && executionState === localExecutionState?.loading"
  class="x-info-transition info-bar"
  [ngClass]="{ 'x-ng-sidebar-is-close': !sidebarOpen }"
>
  <span style="color: #ffffff">{{ 'information.loading' | translate }}</span>
</div>

<div
  *ngIf="enableMessage && executionState === localExecutionState?.success"
  class="x-info-transition success-bar"
  [ngClass]="{ 'x-ng-sidebar-is-close': !sidebarOpen }"
>
  <span style="color: #ffffff">{{ 'information.success' | translate }}</span>
</div>

<div *ngIf="enableMessage && executionState === localExecutionState?.error && title && subtitle">
  <div class="area-bar">
    <div class="error-bar">
      <span class="title">{{ title | translate }}</span>
      <br />
      <span class="subtitle">{{ subtitle | translate }}</span>
    </div>
  </div>
</div>
